import { createUseStyles } from 'react-jss'
import { colors } from '../../variables.style'

export const DOWNLOAD_LINK_HEIGHT = 20

const isFirefoxSafari = navigator.userAgent.indexOf('Firefox') !== -1 || navigator.userAgent.indexOf('Safari') !== -1

export const style = {
  chartSide: {
    backgroundColor: colors.backgroundGray,
    willChange: 'transform, opacity',
    backfaceVisibility: 'hidden',
    marginTop: 1,
    width: '100%'
  },
  hideToggle: {
    contentVisibility: 'hidden',
    ...isFirefoxSafari && { display: 'none' },
    width: '0%'
  },
  tableSide: {
    extend: 'chartSide',
    height: '100%'
  },
  table: {
    overflowY: 'auto',
    paddingBottom: 25
  },
  tableBottomFade: {
    position: 'relative',
    marginTop: -40,
    marginRight: 15,
    height: 40,
    backgroundImage: `linear-gradient(to bottom, rgba(255, 255, 255, 0), ${colors.backgroundGray})`
  },
  downloadLink: {
    display: 'flex',
    justifyContent: 'center',
    lineHeight: `${DOWNLOAD_LINK_HEIGHT}px`
  }
}

export const useStyles = createUseStyles(style)
